import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, Select, TextField } from 'seagull';
import { positiveQuantityInputProps } from '~/constants';
export default function DiscountTextField(props) {
    const { value, onChange, testId, isBillInStages, isBundle } = props, rest = _object_without_properties(props, [
        "value",
        "onChange",
        "testId",
        "isBillInStages",
        "isBundle"
    ]);
    const isPercentDiscount = value.type === 'percent';
    return /*#__PURE__*/ _jsx(TextField, _object_spread({
        disableSuffixPadding: true,
        isPercentage: isPercentDiscount,
        isMoney: !isPercentDiscount,
        inputProps: positiveQuantityInputProps,
        value: value.amount,
        testId: testId && testId + '-amount',
        onChange: (e)=>{
            const amount = e.target.value;
            onChange({
                amount,
                type: value.type
            });
        },
        suffix: /*#__PURE__*/ _jsx(Select, {
            preventOutline: true,
            width: 60,
            minWidth: 60,
            size: props.size,
            disabled: props.disabled,
            SelectProps: {
                autoWidth: true
            },
            value: value.type,
            testId: testId && testId + '-type',
            onChange: (e)=>{
                const type = e.target.value;
                onChange({
                    type,
                    amount: value.amount
                });
            },
            onBlur: rest.onBlur,
            children: [
                {
                    value: 'percent',
                    text: '%'
                },
                {
                    value: 'value',
                    text: '$'
                }
            ].map((param)=>{
                let { value, text } = param;
                const isBillInStagesAndNonPercentage = isBillInStages && value !== 'percent';
                const isBundleAndNonPercentage = isBundle && value !== 'percent';
                return /*#__PURE__*/ _jsx(MenuItem, {
                    disabled: isBillInStagesAndNonPercentage || isBundleAndNonPercentage,
                    value: value,
                    testId: testId && "".concat(testId, "-option-").concat(value),
                    tooltipProps: {
                        title: isBillInStagesAndNonPercentage ? 'Must be a percentage when billing in stages' : isBundleAndNonPercentage ? 'Discount can only be applied as a percentage' : ''
                    },
                    children: text
                }, value);
            })
        })
    }, rest));
}
